import { HealthcareServiceRenderFragment } from '@eluve/fhir-renderer';
import { graphql } from '@eluve/graphql-fhir';

/**
 * The catalog list read: a Connection root for true totals + bounded paging,
 * selections from the entity's render fragment so nothing the view renders
 * is under-selected.
 */
export const SERVICES_QUERY = graphql(
  `
    query FhirServices($offset: Int) {
      HealthcareServiceConnection(
        _count: 200
        _offset: $offset
        _sort: "name"
      ) {
        count
        offset
        edges {
          resource {
            ...HealthcareServiceRender
          }
        }
      }
    }
  `,
  [HealthcareServiceRenderFragment],
);
